import { useThemeModeContext } from "../context/ThemeModeContext";

export function useThemeMode() {
  return useThemeModeContext();
}
